import React, { useRef, useEffect, useState } from 'react';
import './Guide.css';
import { trackEvent } from '../../utils/analytics';
import TryFreeBtn from '../../components/TryFreeBtn';

const Guide = () => {
  const [videoEnded, setVideoEnded] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const unmuteTrackedRef = useRef(false);
  const videoRef = useRef(null);

  useEffect(() => {
    let playTimer;
    if (window.location.hash === '#video') {
      trackEvent('Ad', 'landing', 'Guide Video From Ad');
      const videoSection = document.getElementById('video');
      if (videoSection) {
        videoSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        playTimer = setTimeout(() => {
          if (videoRef.current) videoRef.current.play().catch(() => {});
        }, 800);
      }
    }

    const video = videoRef.current;
    if (video) {
      const handleVolumeChange = () => {
        setIsMuted(video.muted);
        if (!video.muted && !unmuteTrackedRef.current) {
          trackEvent('Video', 'unmute', 'OW Client Guide Video');
          unmuteTrackedRef.current = true;
        }
      };
      video.addEventListener('volumechange', handleVolumeChange);
      return () => {
        clearTimeout(playTimer);
        video.removeEventListener('volumechange', handleVolumeChange);
      };
    }

    return () => clearTimeout(playTimer);
  }, []);

  const handleVideoEnded = () => {
    setVideoEnded(true);
    trackEvent('Video', 'complete', 'OW Client Guide Video');
  };

  const handleReplayVideo = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
      setVideoEnded(false);
    }
    trackEvent('Video', 'replay', 'OW Client Guide Video');
  };

  const handleUnmute = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.volume = 1;
      if (videoRef.current.paused) videoRef.current.play().catch(() => {});
    }
  };


  return (
    <div className="guide-page">
      <section id="video" className="guide-app-section">
        <div className="container">
          <div className="guide-app-box">
            <div className="guide-app-content">
              <h2>OW Platform Giude</h2>
              <div className="gd-offer-banner">
                First Month for Free!<br />Then only <strong>100 Euro/month</strong> per Subscription — no commitment, cancel anytime.<br />
                <span className="gd-offer-limited">⚡ Limited Offer!</span>
              </div>
              <ul className="guide-benefits-list">
                <li>Spare the money: lower staff number = lower salary costs</li>
                <li>Spare the time: when it gets busy, the app will keep taking orders and will eliminate waiting time from your quests and their bad reviews</li>
                <li>Spare the trouble: qualified waiters are expensive and hard to find. OW Client will solve this for you.</li>
                <li>Spare some frustrations: no more order misunderstanding caused by language differences</li>
                <li className="guide-video-cta-item" onClick={handleUnmute} style={{cursor: 'pointer'}}>
                  <strong>Watch the Video <span className="guide-sound-badge">🔊 With Sound!</span></strong> It will take only 3 minutes of your time, and reveal much more benefits
                </li>
              </ul>


              <div className="guide-buttons-group">
                <TryFreeBtn />
              </div>

            </div>
            <div className="guide-app-video-wrapper">
              <div className="guide-app-video-column">
                <div className="guide-app-video">
                  <div className="guide-video-container">
                    <video
                      ref={videoRef}
                      controls
                      muted
                      className="guide-video"
                      onEnded={handleVideoEnded}
                      playsInline
                    >
                      <source src={`${process.env.PUBLIC_URL}/video/ow-platform-final-eng.mp4`} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>

                    {isMuted && !videoEnded && (
                      <div className="guide-unmute-overlay">
                        <button className="guide-unmute-btn guide-unmute-center-btn" onClick={handleUnmute}>
                          <div className="guide-unmute-arrows-left">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="guide-hint-arrow">
                              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                            </svg>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="guide-hint-arrow">
                              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                            </svg>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="guide-hint-arrow">
                              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                            </svg>
                          </div>
                          <div className="guide-unmute-center-label">
                            <svg className="guide-hint-unmute-icon" viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                              <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
                            </svg>
                            <span className="guide-hint-unmute">Unmute!</span>
                          </div>
                          <div className="guide-unmute-arrows-right">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="guide-hint-arrow">
                              <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                            </svg>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="guide-hint-arrow">
                              <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                            </svg>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="guide-hint-arrow">
                              <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                            </svg>
                          </div>
                        </button>
                      </div>
                    )}

                    {videoEnded && (
                      <div className="guide-video-end-controls">
                        <div className="guide-video-end-buttons">
                          <button className="guide-video-control-btn replay-btn" onClick={handleReplayVideo}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                              <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
                            </svg>
                            <span>Replay</span>
                          </button>
                          <TryFreeBtn />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="guide-buttons-group guide-action-buttons-mobile">
                  <TryFreeBtn />
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Guide;
